import React, { useEffect, useRef, useState } from "react";
import styles from "./scss/chatframe.module.scss";

import LeftsideBars from "./leftsidebar";
import TopHeader from "./chatsection/topheader";
import ChatTopics from "./chatsection/chattopic";

import RightSidebar from "./rightsidebar";
import ChatBottom from "./chatsection/chatbottom";
import { Tabs, Tooltip } from 'antd';
import ChatInnerFrame from "./chatInner";
// import NotificationBottom from "./chatWidgets/notificationBottom";
import CreateNote from "../chat/rightsidebar/notecreate";
import {Modal} from 'antd';
import WhileAttach from "./chatsection/whiteattach";
import MainMenus from "../../common/menus";
import { chats, chatwindowDetails, initialStateModel, LoginState, startaScreenModel } from "../../models/model";
import { useSelector } from "react-redux";
import FileListCenter from "../contacts/contactWidgets/contactFiles";
import ContactLinksChat from "../contacts/contactWidgets/contactLinks";
import ContactSavedChat from "../contacts/contactWidgets/contactSavedChat";

import noResult from "../../styles/images/empty_states/empty-nofound.svg";
import { compressed_img, Cookie, getcontactDetail, LeftSavedChatClear, Logout, SearchConversationFilter } from "../../base/utils";
import ChatNewdrpdown from "./chatWidgets/userDropdown";
import TaskContactMain from "../contacts/rightsidebar/taskContactMain";
import EventContactMain from "../contacts/rightsidebar/eventContactMain";
import NotesContactMain from "../contacts/rightsidebar/notesContactMain";
import { URAvatarGroup } from "../../shared/widgets/avatarGroup";
import { ChatService } from "../../base/chatService";
import { URStatusDot } from "../../shared/widgets/avatarGroup/statusDot";
import { toastInformation, userStatusColor } from "../../base/callService/common";
import { callMainPageInterface } from "../../models/callModel";
import ToastLeft from "../../shared/widgets/toastScreenleft";
import NewEventRightCreate from "./rightsidebar/neweventright";
import { chatSideWindow } from "../../base/eventService/eventApiService";
import CreateTask from "../contacts/rightsidebar/taskcreate";
//import ChatToastRight from "../maincomponents/toastScreenright";
import Lottie from "lottie-react";
import ContactLoader from "../../styles/images/Lottie Animation.json";
import EditEventRightBar from "./rightsidebar/editeventright";
import TaskViewDetails from "./rightsidebar/taskviewdetails";
import { SocketChatService } from "../../base/socketChatService";
import { generateChatID, totalTabBatchcount, userInfo } from "../../base/socketChatService/utils";
import { URButton } from "../../shared/widgets/button";
import ToastUndo from "../chat/chatWidgets/toastScreenUndo";
import store from "../../context/store/store";
import { Types } from "../../context/action/action";
import NoteViewRight from "../contacts/rightsidebar/noteview";
import messagEncypt from "../../styles/images/chatencrypt.svg"
import landingicon from "../../styles/images/landingicon.svg"
import _ from 'lodash';
//import MonthlyMeetUp from "../../common/MonthlyMeetUp";
//import InnerEncryption from "../../common/innerEncryption";
//import { contactService } from "../../base/contactService";
//import { uuidv4 } from "../../base/meetingService/utils/meetingServices";
import { unregister } from "../../base/callService/callService";
import { useHistory } from "react-router";
import ReadReceiptList from "./rightsidebar/readreceiptlist";
import InnerEncryption from "../../common/innerEncryption";
import NoContent from "../../shared/widgets/noContent";
import { Meetingnotifications } from "../videonotifications/Meetingnotifications";
import { handelMeetingNotification } from "../../base/socketChatService/newChat";
import Deleteconfirmsec from "./chatsection/deleteconfirmsec";
import CreateDropDown from "./leftsidebar/createdropdown";
import closeIcn from "../../styles/images/closeicon.svg";	
type RightSidebarSte = {
  openList: any;
  showDragDrop: boolean;
}

type popoverState = {
  isArchive:boolean;
  isDelete:boolean;
  archiveChat:any;
  deleteData:any;
  deleteChat:any;
}
const Chats = () => {
  const { TabPane } = Tabs;
  const chatWindowDetailReducer: chatwindowDetails = useSelector((state: initialStateModel) => state.chatWindowReducer);
  const {  toastReducer}: callMainPageInterface =  useSelector((state: callMainPageInterface) => state);
  const loginDetails: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  const socketRecentReducer = useSelector((state: initialStateModel) => state.chatSocketReducerState);
  const socketRecentStateReducer = useSelector((state: initialStateModel) => state.chatSocketRecentReducerState);
  const chatReducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  const toastUndo: any = useSelector((state: any) => state.toastReducer);
  const allContacs: any = useSelector((state: initialStateModel) => state.contactReducer);
  const initalState: any = useSelector((state: any) => state.serverDisconnectReducer);
  const { startingScreenLoader}: startaScreenModel = useSelector((state: initialStateModel) => state.startingScreenReducer);
  let deleteContact = allContacs?.deleteContacts;
  let meetingReducer: any = store.getState().meetingReducer;
  //let {contactReducer } = allReducer;
  //const contactList: contacts = contactReducer;
  //const chatSocket = new SocketChatService(userInfo().fromID,userInfo().domainId);
  const history = useHistory();
  let { userdetails,landingPage } = loginDetails;
  let socketService = useRef<any>(null);
  const [getItem, setItem] = useState<RightSidebarSte>({
    openList: 'all',
    showDragDrop:false
  });

  let { isChatWindow, isMySpace,chatWindowDetails,isNewMessageWindow,windowResize } = chatWindowDetailReducer;
  //const [isActive, setActive] = useState(false);
  const [isActiveone, setActiveone] = useState(false);
  const [scroll,setScroll] = useState<number>(-1);
  const [notif,setNotif] = useState<boolean>(true);
  const windowRef = React.useRef(window);
  const [mount,setMount] = useState<boolean>(false);
  const [isNotfound, setNotfound] = useState(false);
  const [ArchiveModal, setArchiveModal] =useState<popoverState>({isArchive:false,isDelete:false,archiveChat:{},deleteData:{},deleteChat:{}})
  const [profileDetails,setProfileDetails]= useState({
    isLeaveModel: false
  })
 
  const BORDER_SIZE = 4;
  const openLeaveModal = () => {
 
    let adminValue = chatWindowDetails?.admin_members ? chatWindowDetails?.admin_members.split(",") : [];
    let teamMember = chatWindowDetails?.team_members ? chatWindowDetails?.team_members.split(",") : []
    adminValue = adminValue.map((contactdata: any) => (contactdata.trim()));
    if (teamMember.length !== 1 && adminValue.length === 1 && adminValue.includes(userdetails.sip_login_id))
    {
      toastInformation('To leave this group, assign an Admin', "failure")
    } else {
      setProfileDetails({ ...profileDetails, isLeaveModel: true });
    }
   
  }
  let memberList = chatWindowDetails?.team_members ?  chatWindowDetails?.team_members?.split(",") : [];
  memberList = memberList.map((contactdata: any) => (contactdata.trim()));
  let statusMember =memberList.includes(userdetails?.sip_login_id);

  let {replyMessageDetails,editMessageDetails}  = chatReducer;
  let {isReply} = replyMessageDetails;
  let {isEditing} = editMessageDetails;
  let m_pos:any;

  const visibilebrowsertabClick =() =>{
      let { chatWindowDetails }: chatwindowDetails = store.getState().chatWindowReducer;
      let { userdetails }: LoginState = store.getState().loginReducer;
      let contactsDetail=chatWindowDetails;
       
        if(contactsDetail?.sip_login_id || contactsDetail?.team_id){
              const socketservice = new SocketChatService(userdetails?.sip_login_id,userdetails?.domain_id);
              let { recentChatList }: any = store.getState().chatSocketRecentReducerState;
              let sip = contactsDetail?.team_id ? 'con'+ contactsDetail?.team_id : contactsDetail?.sip_login_id
              let recentChat = recentChatList[sip];
              
              if((recentChat?.lastmessage?.direction === "IN") && ((contactsDetail?.sip_login_id  && recentChat?.lastmessage?.deliveryStatus !== 8) || (contactsDetail?.team_id  && recentChat?.lastmessage?.readreport['s'+userdetails.sip_login_id] === undefined))){
                socketservice.openChatWindow(contactsDetail, history,recentChat);
              }
          
        }
  }
  document.addEventListener("visibilitychange", (e) => {
    if (document.visibilityState === "visible") {
        console.log("tab is active index");
        window.location.pathname === '/chats' && visibilebrowsertabClick();
        e.stopImmediatePropagation();
    } else {
      //console.log("tab is inactive index");
        e.stopImmediatePropagation();
    }
  });
 
  useEffect(() => {



    const userInfo:any =Cookie.get();
    const userInfosess: any = sessionStorage.getItem("userinfo");
     if(!userInfosess){
  
      setTimeout(()=>{
        ChatService.reInitsession();
      }, 2000)
    
    }
   store.dispatch({
    type: Types.HISTORY_SET,
    payload: {
      historySet: history
    }
  });

  
    const recentChat:any = socketRecentStateReducer.recentChatList;
    let chromeCount:any = totalTabBatchcount();
    document.title= chromeCount > 0 ?"Worktual Web Application ("+ chromeCount +")" : "Worktual Web Application";
   
    const recentArray = Object.values(recentChat).length>0 ? Object.values(recentChat):[];
    if(recentArray.length>0 && !isNewMessageWindow){
      var result = _.orderBy(recentArray, ['updatedAt'], ['desc']);
      var deletedArray = _.filter(result, (value:any)=>{
        return !value.settings.isDeleted || !value.settings.isDeleted["s"+userdetails.sip_login_id.toString()]
      })
      var unreadRes:any = _.find(result, (value:any)=>{
        return value.chatId === chatWindowDetails?.chatId
      })
      if(unreadRes?.unreadCount > 0){
        const socketservice = new SocketChatService(userdetails?.sip_login_id,userdetails?.domain_id);
        socketservice?.markAsRead(unreadRes);
      }
    
      if(Array.isArray(deletedArray) && deletedArray.length>0){
        // console.log('deletedArray --->',deletedArray);
        const contactList = deletedArray[0];
        let contactObject: any = store.getState().contactReducer;
        let workContact = contactObject?.workContactsnew;
        let teamContacsnew = contactObject?.teamContacsnew;
      if(contactList?.type===1 && _.isUndefined(workContact[contactList?.sip_login_id])===false && socketService.current){
        let chatDetail ={chatId:generateChatID(userdetails?.sip_login_id?.toString(), contactList?.sip_login_id?.toString())};
        socketService.current.openChatWindow(contactList,history,chatDetail);
      }
      if(contactList?.type===2 && _.isUndefined(teamContacsnew["con"+contactList?.team_id])===false && socketService.current){
        socketService.current.openChatWindow(teamContacsnew["con"+contactList?.team_id],history);
      }
      }
    }
  }, [history]);

  useEffect(()=>{
    if(initalState?.serverDisconnect){
      console.log("LOgout 3")
     try{
      //Logout().then(()=>{
        const chatService = new SocketChatService(userInfo().fromID, userInfo().domainId);
        if(chatService.socketConnection){
          chatService.socketConnection.closeConnection();
          }
        chatService.destroy();
        chatService.eventEmit = null;
        chatService.socketConnection = null;
        Cookie.clear();
        localStorage.clear();
        sessionStorage.clear();
        SocketChatService._instance = null;
        unregister();
        history.push("/login");
        history.replace("/login")
     } catch(error:any){
      console.log(error,"error")
     }

      //});
    }
  },[initalState?.serverDisconnect]);

  useEffect(()=>{
    var focusableInputElements:any = document.querySelectorAll(".tranText");
   
    if(focusableInputElements?.length === 0 && chatReducer.searchData !== "" && chatReducer.searchData !== undefined){
      let filRes:any =  SearchConversationFilter(socketRecentReducer?.messageList,chatReducer?.searchData);
      let boolRes = filRes?.length > 0 ? false:true;
      setNotfound(boolRes);
    } else {
      setNotfound(false);
    }
    
  },[toastUndo,chatReducer.searchData])

  useEffect(()=>{
    if (toastReducer.meetingNotify.title !== undefined) {
      //console.log('toastReducer.meetingNotify -- > -- ', toastReducer.meetingNotify);
      //openNotification('topRight', toastReducer.meetingNotify);
     Meetingnotifications('topRight', toastReducer.meetingNotify, history);
     handelMeetingNotification({});
    }
  },[toastReducer.meetingNotify])
  const closeToast = () =>{
    const socketChat = new SocketChatService(userInfo().fromID, userInfo().domainId);
    socketChat.toastUndo("","")
  }

  const selectStartDrag = (e:any) =>{
    e.preventDefault();
  }

  const onUndoClick = ()=> {

    clearTimeout(toastUndo.callback);

    const socketChat = new SocketChatService(userInfo().fromID, userInfo().domainId);

    socketChat.toggleUndo(true);
      toastInformation("Undo Successful !","success")
    socketChat.toastUndo("","")

  }
  useEffect(()=>{
    const userInfo:any =Cookie.get();
    const userInfosess: any = sessionStorage.getItem("userinfo");
    if(userInfosess){
      const cookieData =JSON.parse(userInfosess);
      socketService.current= new SocketChatService(cookieData.sip_login_id, cookieData.domain_id);
    }
    setScroll(-1);
  },[chatWindowDetails]);
  useEffect(()=>{
    //setActive(chatReducer.isWindowSlide);
    const panel:any = document.getElementById("right_panel_chatwind") || null;
    const chatwindowFrame = document.getElementById("frameinsection-resize") || null;
    const resize = (e:any) =>{
      if(panel && chatwindowFrame){
        const dx = m_pos - e.x;
        m_pos = e.x;
        panel.style.width = (parseInt(getComputedStyle(panel, '').width) + dx) + "px";
        chatwindowFrame.style.width = 'calc(100% - '+(parseInt(getComputedStyle(panel, '').width) + dx) + "px)";

      }
    };
    windowRef.current.addEventListener("mousedown", function(e:any){
      // const panel:any = document.getElementById("right_panel_chatwind") || null;
      if (e.offsetX < BORDER_SIZE) {
        m_pos = e.x;
        windowRef.current.addEventListener('selectstart', selectStartDrag);
        windowRef.current.addEventListener("mousemove", resize, true);
      }
    }, true);
    windowRef.current.addEventListener("mouseup", function(){
      // const panel:any = document.getElementById("right_panel_chatwind") || null;
      windowRef.current.removeEventListener("mousemove", resize, true);
      windowRef.current.removeEventListener('selectstart', selectStartDrag);
    }, true);
    return ()=> {
      // const panel:any = document.getElementById("right_panel_chatwind") || null;
      windowRef.current.removeEventListener("mousemove", resize);};
    
  },[document.getElementById("right_panel_chatwind"),chatReducer.isWindowSlide, mount]);
  const  handleScroll = (e:any) => {
    if(Array.isArray(socketRecentReducer.messageList) && socketRecentReducer.messageList.length>0){
    const targetEl = e.target;
    const elemHeight:any = document.getElementById("chatWindow")?.clientHeight || null;
    if ((targetEl.scrollTop + document.getElementById('chatWindow')?.scrollHeight) -4 < elemHeight) {
      const socketChat = new SocketChatService(userInfo().fromID, userInfo().domainId);
      if(chatWindowDetails?.sip_login_id ){
        socketChat.scrollToArchive(generateChatID(userInfo().fromID, chatWindowDetails?.sip_login_id.toString()));
      } else {
        socketChat.scrollToTeamArchive(chatWindowDetails)
      }
    }
    setScroll(e.target.scrollTop);
      // ChatService.scrollArchive();
    }
  };

  const handleCancel =()=>{
    setArchiveModal({...ArchiveModal,isDelete:false,deleteData:{},deleteChat:{}})
 }
  const handleToggle = () => {
    // const chatwindowFrame = document.getElementById("frameinsection-resize") || null;
    // if(chatwindowFrame)
    //   chatwindowFrame?.removeAttribute('style');
    // // setActive(!isActive);
    // setItem({ ...getItem, openList: chatReducer.isWindowSlide && 'all' });
    // chatSideWindow(!chatReducer.isWindowSlide,"",{});
    ChatService.rightSideToogle();
  };
  const handleToggleone = () => {
    setActiveone(!isActiveone);
  };
  
  /*  const openChatWindow = (userdetails:any)=>{

     console.log("userdetails >>>>>", userdetails);

 
     setContactDetails(userdetails);

     setChatwindow(true);

   } */

  let teamMemberNames: any = [];
  let teamMemberarrayforImage = chatWindowDetails?.team_id
    && chatWindowDetails?.team_members &&
    chatWindowDetails?.team_members?.replace(" ", "").split(',');
  teamMemberarrayforImage?.map((list: any) => {
    let c_details = getcontactDetail(list);

    teamMemberNames.push(c_details?.caller_id);
  });
 
  const handleDragEnter = (event: any) => {
    event.preventDefault();
    setItem({ ...getItem, showDragDrop: true });
  };
  
  const handleDragOver = (event: any) => {
    event.preventDefault();
  };
  
  // const closeNotification = () =>{
  //   // setNotif(false)
  // }
  const deleteAction=()=>{
    let chatDetails = {
       chatId : ArchiveModal?.deleteChat?.chatId,
       settingsKey : "isDeleted",
       status : 1
     }
     socketService.current.updateRecentChatSettings(chatDetails);
    LeftSavedChatClear();
     setArchiveModal({...ArchiveModal,isDelete:false,deleteData:{},deleteChat:{}})
 };
const deleteTeam = () =>{
  const recentChat:any = socketRecentStateReducer.recentChatList;
if(recentChat?.["con"+chatWindowDetails?.team_id]){
  setArchiveModal({...ArchiveModal,isDelete:true,deleteData:chatWindowDetails?.team_id,
    deleteChat:recentChat?.["con"+chatWindowDetails?.team_id]})
}
}
  // const enablePermission = () =>{
  
  //   Notification.requestPermission().then(function(permission) {
  //     if(permission==="denied"){
  //       toastInformation('Please manually enable permission','success')
  //     } else if(permission==="granted"){
  //       setNotif(false)
  //     }
  //   });

  // }

  const handleDrop = (event: any) => {
    event.preventDefault();
    let files = [...event.dataTransfer.files];
    for (let i = 0; i <files.length; i++) {
      let filesinfo:any = {};
      filesinfo.fileName = files[i].name;
      filesinfo.fileType = files[i].type;
      filesinfo.filePath =  window.URL.createObjectURL(files[i]);
      filesinfo.filesize =files[i].size;
      filesinfo.targetFile = files[i];
      filesinfo.messageType = "FILE";
      filesinfo.txt = ""
      ChatService.fileUpload(filesinfo);
    }
    setItem({ ...getItem, showDragDrop: false });
  };
const changeTab=(key:any)=>{

store.dispatch({
  type: Types.TAB_CHANGE,
  payload: {
    ActiveTab: key
  }
});

}
const closeLeaveModal = () => {
  setProfileDetails({ ...profileDetails, isLeaveModel: false });
}
const leaveFromTeam = async () => {
  let groupLeaveMembersInfo = {
    companyId: userdetails.company_id,
    teamId: chatWindowDetails?.team_id,
    leaveMemberSipId: userdetails.sip_login_id.toString()
  };
  socketService.current.leaveMember(groupLeaveMembersInfo);
  setProfileDetails({ ...profileDetails, isLeaveModel: false });
  toastInformation(chatWindowDetails?.team_name+" has left the group", "success");
};
const selectforwardAll = ()=>{
  ChatService.onChangeForwardWindow(true,'multi');
  //ChatService.onMultiOptionWindow('forward');
}
const selectdeleteAll = ()=>{
  ChatService.onChangeDeleteWindow(true,'multi');
}
const selectSaveall = ()=>{
  ChatService.saveallMessage(chatReducer.selectMessageData,'multi');
  ChatService.onChangeForwardWindow(false,'');
  ChatService.onMultiOptionWindow(false);
}
const selectDowndloadall = ()=>{
  compressed_img(chatReducer.selectMessageData,"fileee");
  ChatService.onChangeForwardWindow(false,'');
  ChatService.onMultiOptionWindow(false);
  toastInformation("Save to device successfully", "success");
}
var deletedHover = _.filter(chatReducer.selectMessageData, (value:any)=>{
  return value?.direction === 'IN'
})

var imgHover = _.filter(chatReducer.selectMessageData, (value:any)=>{
  return value?.message?.messageType === 'IMAGE' || value?.message?.messageType === 'FILE'
})
let teamMemberOnly =
chatWindowDetails?.team_members && chatWindowDetails?.team_members
  ? chatWindowDetails?.team_members.split(",").map((ele: any) => ele.trim())
  : [];

let size:any = (deleteContact[chatWindowDetails?.sip_login_id] !== undefined  || (chatWindowDetails?.team_id && !teamMemberOnly.includes(userdetails?.sip_login_id.toString().trim()))) ? 223 :240
let resize:any = 'calc(100vh - '+(parseInt(size + (windowResize))) + "px)"
let myspaceresize:any = 'calc(100vh - '+(parseInt(312 + (windowResize))) + "px)"
  return (
    <>
     
     {(startingScreenLoader) && <InnerEncryption fromComponent={"Message"} icon={messagEncypt} />}
   
      <div className={styles.mainframe}>
        <div className={styles.framemenu}>
          <MainMenus></MainMenus>
        </div>
        <div className={isActiveone ? `${styles.frameleftsidebar}`
          : `${styles.frameleftsidebar} ${styles.hideframeleftsidebar}`}>
          <div className={styles.mobilemenu} onClick={handleToggleone}><span className="icon_close"></span></div>
          <div className={styles.landheadermainleft}>
            <LeftsideBars ></LeftsideBars>
          </div>
          
        </div>
        <div className={styles.framemain}>
          <div className={styles.frameheader}>
            <div className={styles.mobilemenu} onClick={handleToggleone}>Menus</div>
            <TopHeader></TopHeader>
          </div>
          
          {isNewMessageWindow &&
            <>
              <div className={chatReducer.isWindowSlide ? `${styles.framemainsection} ${styles.framecolappse}`
                : `${styles.framemainsection}`}>
                <ChatNewdrpdown />
                <div className={styles.chatmainsections} >
                  <div className={ isNewMessageWindow ?  `${styles.NewMessageWindowsec} scroller`: `scroller ${styles.chatinnerframe}`}
                   id="chatWindow" onScroll={handleScroll}> 
                    {/* <ImageZoom></ImageZoom> */}
                    <ChatInnerFrame />
                  </div>
                </div>
                <div id="chatbot" className={`${styles.chatbottoms}  ${ isEditing ? styles.actionFlow : ""} ${isReply ? styles.actionFlow:""}`}>
                  <ChatBottom scroll={scroll}></ChatBottom>
                  {/* <div className="chatForward">
                    ksdjbfkjsdbfkhjdsf
                  </div> */}
                </div></div>
            </>}
            {!landingPage && <>
          {isChatWindow ? (
            <>
              <div id="frameinsection-resize" className={chatReducer.isWindowSlide ? `${styles.framemainsection} ${styles.framecolappse}`
                : `${styles.framemainsection}`}
              onDrop={(event) => handleDrop(event)}
              onDragOver={(event) => handleDragOver(event)}
              onDragEnter={(event) => handleDragEnter(event)}
              >
                {/* <Tooltip mouseEnterDelay={0.5}  placement="left" title={chatReducer.isWindowSlide ? 'Click to collapse' : 'Click to expand'}>
                  <div className={chatReducer.isWindowSlide ? ` fadeIn ${styles.arrowsnav} ${styles.arrowchange}` : `${styles.arrowsnav}`}
                    onClick={handleToggle}><span className="icon_Strokeleftarrow"></span></div>
                </Tooltip> */}
                {/* <Tooltip placement="left" title="Hold and resize">
                  <div className={styles.holdraise}></div>
                </Tooltip> */}
                <div className={styles.topsections}>
                  <ChatTopics ></ChatTopics>
                </div>

                <div className={styles.chatmainsections} >
                  {chatReducer.chatLoader &&  <Lottie width={150} className="svgLoading forchatsvg"
                    animationData={ContactLoader} />}
                  <div className={`scroller ${styles.chatinnerframe} ${socketRecentReducer?.messageList?.length===0 ? styles.empty :"" }`} style={{minHeight:resize,maxHeight:resize}}  id="chatWindow" onScroll={handleScroll}>
                    {/* <ImageZoom></ImageZoom> */}
                    {isNotfound ? <NoContent image={noResult}
              title={''}
              description={'Oh,no results found'} />:  <ChatInnerFrame />}
                   
                   
                  </div>
                </div>

                {/* ${styles.shareFlow}`} ${styles.actionFlow} */}
                <div id="chatbot" className={!notif?`${styles.chatbottoms} ${ isEditing ? styles.actionFlow : ""} ${isReply ? styles.actionFlow:""}`:`${styles.chatbottoms} ${styles.notificationEnable}  
                ${ isEditing ? styles.actionFlow : ""} ${isReply ? styles.actionFlow:""}`}>
                  <ChatBottom scroll={scroll}></ChatBottom>
                 {chatReducer?.multiOption &&<div className="chatForward">
                    <span className="icon__Forward" onClick={selectforwardAll}/>
                    <span className="icon__Saved" onClick={selectSaveall} />
                    {deletedHover?.length === 0 && <span className="icon__Delete" onClick={selectdeleteAll}/>}
                    {imgHover?.length > 0 ?<span className="icon__Download" onClick={selectDowndloadall} /> :""}
                  </div>}
                </div>
                {getItem.showDragDrop &&
                  <WhileAttach name={chatWindowDetails?.team_id ?
                    chatWindowDetails.team_name :
                    chatWindowDetails.caller_id}></WhileAttach>
                }
                {/* <WhileAttach></WhileAttach> */}
                {/* <InnerEncryption />  */}
              </div>

            </>

          ) : isMySpace ?
            <div id="frameinsection-resize" className={chatReducer.isWindowSlide ? `${styles.framemainsection} ${styles.framecolappse}`
                : `${styles.framemainsection}`}
              onDrop={(event) => handleDrop(event)}
              onDragOver={(event) => handleDragOver(event)}
              onDragEnter={(event) => handleDragEnter(event)}
              >
          
              <Tooltip placement="left" title={chatReducer.isWindowSlide ?  'Click to collapse' : 'Click to expand'}>
              { isMySpace &&  <div className={chatReducer.isWindowSlide ? ` fadeIn ${styles.arrowsnav} ${styles.arrowchange}` : ` ${styles.arrowsnavHiden}`}
                  onClick={handleToggle}><span className="icon_Strokeleftarrow"></span></div>}    
                    
              </Tooltip>
              <Tooltip placement="left" title="Hold and resize">
                <div className={styles.holdraise}></div>
              </Tooltip>
              <div className={`${styles.topsections} ${styles.myspaceTop}`}>
                <div className={styles.profilelists}>
                  {/* <div className={styles.lefts}> */}
                  <URAvatarGroup className='lefts size38 colorBG1' profileInfo={
                    <>
                      {userdetails.profile_url ?
                        <img src={userdetails.profile_url} alt="" />
                        :<span>{userdetails.caller_id.charAt(0).toUpperCase()}</span>
                      }
                      <URStatusDot className={userStatusColor(userdetails?.user_status,'small')}/>
                    </>
                  }/>
                  
                  {/* <span>{ userdetails.profile_url? <img src={userdetails.profile_url} alt=""/>
                      :
                      userdetails.caller_id.charAt(0)}<b></b></span> */}
                  {/* </div> */}
                  <div className={styles.middle}>
                    {/* <h4><b>{chatWindowDetails.caller_id}</b></h4> */}
                    {chatWindowDetails?.caller_id?.length > 35 && <Tooltip mouseEnterDelay={0.5} title={chatWindowDetails?.caller_id}
                      className='cusTooltip' overlayClassName='customTooltip'>
                      <h4 title="View profile">{chatWindowDetails?.caller_id}</h4>
                    </Tooltip>}
                    {chatWindowDetails?.caller_id?.length < 35 && 
                      <h4 title="View profile">{chatWindowDetails?.caller_id}</h4>
                    }
                    {/* <div className={styles.actionIcon}>
                    {chatWindowDetails.cli && <span>{chatWindowDetails.cli}</span>}
                      <span>{chatWindowDetails.ext}</span>
                    </div> */}
                      {/* <div className={styles.callExtNo}>
                        <ul>
                            <li><Tooltip mouseEnterDelay={0.5} placement="top" title="Extension Number"><span>{chatWindowDetails?.ext}</span></Tooltip></li>
                        </ul>
                      </div> */}
                  </div>
                 
                </div>
              </div>

              <div className={`${styles.chatinnerframe}`} id="chatWindow" onScroll={handleScroll}>
                <div className={`${styles.tabHeader}`}>
                  <Tabs /*tabBarExtraContent={operations}*/ className="myspaceSec "  activeKey={chatReducer.ActiveTab}
                  onChange={changeTab}
                  >

                    <TabPane tab="Chat Me" key="1">
                      {/* <ChatFilesMessage  /> */}
                      { (chatReducer.isForward||chatReducer.isDelete || chatReducer.multiOption) && <Deleteconfirmsec />}
                      <div className={styles.mySpaceInnerChat} style={{minHeight:myspaceresize,maxHeight:myspaceresize}} >
                        <ChatInnerFrame />
                        <div className={`${styles.chatbottoms} ${ isEditing ? styles.actionFlow : ""} ${isReply ? styles.actionFlow:""}`}>
                          <ChatBottom scroll={scroll}></ChatBottom>
                        </div>
                      </div>
                    </TabPane>
{/* 
                    <TabPane tab="Tasks" key="2">
                      <div className={styles.mySpaceInnerfiles}><TaskContactMain  chatSideWindow={chatSideWindow}/></div>
                    </TabPane> */}
                  
                    {/* <TabPane tab="Events" key="3">
                    <div className={styles.mySpaceInnerfiles}>
                        <EventContactMain chatSideWindow={chatSideWindow} />
                    </div>
                   </TabPane> */}
           
                    <TabPane tab="Files" key="4">
                      <div className={styles.mySpaceInnerfiles}><FileListCenter/></div>
                    </TabPane>
                    <TabPane tab="Saved Chats" key="5">
                      <div className={styles.mySpaceInnerfiles}><ContactSavedChat/></div>
                    </TabPane>
      
                    {/* <TabPane tab="Notes" key="6">
                      <div className={styles.mySpaceInnerfiles } ><NotesContactMain chatSideWindow={chatSideWindow}/></div>
                    </TabPane> */}
                    
                    <TabPane tab="Links" key="7">
                      <div className={styles.mySpaceInnerfiles}><ContactLinksChat /></div>
                    </TabPane>
                  </Tabs>
                </div>
              </div>

              {/* ${styles.shareFlow}`} ${styles.actionFlow} */}

              {/* <ChatNoInternet></ChatNoInternet> */}
              {/* <WhileAttach></WhileAttach> */}
            </div>
            : null}

          {chatReducer.isWindowSlide ? (<div id="right_panel_chatwind" className={chatReducer.isWindowSlide ? `fadeIn ${styles.framerightsidebar}`
            : `${styles.framerightsidebar} ${styles.hideframerightsidebar}`}>
            {chatReducer.isKey === "event"? <NewEventRightCreate module={'chat'}></NewEventRightCreate> :
              chatReducer.isKey === "task"? <CreateTask></CreateTask> :
                chatReducer.isKey === "notes"? <CreateNote isKey={chatReducer.isKey}></CreateNote>:
                chatReducer.isKey === "editnotes"?
                <CreateNote isEdit={chatReducer.isKey ==='editnotes' ? true : false}
                noteData={chatReducer.isEdit} isKey={chatReducer.isKey}></CreateNote>:
                  chatReducer.isKey === "editevent"? <EditEventRightBar isEdit={chatReducer.isEdit}>
                  </EditEventRightBar>:
                    chatReducer.isKey === "edittask"? <TaskViewDetails taskData={chatReducer.isEdit}>
                    </TaskViewDetails>:chatReducer.isKey === 'viewnotes' ?
                          <NoteViewRight chatSideWindow={chatSideWindow} noteData={chatReducer.isEdit}/>:
                          chatReducer.isKey === 'readreceipt' ? 
                          <ReadReceiptList  receiptLists={chatReducer.isEdit}/>:
                      <RightSidebar deleteAction={deleteAction}statusMember={statusMember} deleteTeam={deleteTeam}openLeaveModal={openLeaveModal} teamMemberNames={teamMemberNames}  handleToggle={chatReducer.isWindowSlide} ></RightSidebar>
                      }
            
            {/*<CreateNote></CreateNote>*/}
            {/* <CreateTask></CreateTask> */}
            {/* <div className={styles.rightsidebottomexitbutton}>
            {statusMember && chatWindowDetails.team_id && chatReducer.isKey === "" && <>
              <div className={styles.exitButton} onClick={openLeaveModal}>
              <URButton className='urButton buttonExit buttonSm mr8' name='Exit from team'/>
            </div>
            
            </>}
            {!statusMember&& chatWindowDetails.team_id && 
            recentChat?.["con"+chatWindowDetails?.team_id]?.settings?.isDeleted?.["s"+userdetails?.sip_login_id]===0
            && <div className={styles.delButton} onClick={deleteTeam}>
              <URButton className='urButton buttonExit buttonSm' name='Delete Team'/>
            </div>
            }
            </div> */}
          </div>) : null}
          </>}

         {landingPage && !isNewMessageWindow && 
         <div className={styles.newLanding}>
            <img src={landingicon} alt="" />
            <span className={styles.pageTitle}>Worktual </span>
            <span className={styles.pageDesc}>Communications done different</span>
            <div className={styles.smallText}>
            <p>If things look a bit empty, select a conversation to read Or start a new one</p>
              <span className="icon_lock"></span> End-to-end encrypted.</div>             
          </div>
         
          }
          
        </div>
        {/* <div className={styles.topheaderlanding}>
            <div className={styles.topheadernav}>
                <div className={styles.topleftheadersiderbar}>
                <CreateDropDown></CreateDropDown>
                </div>
                <div className={styles.toprightheadersiderbar}>
                  <div className={styles.marheadertop}>
                  <TopHeader></TopHeader>
                  </div>
                  
                </div>               
            </div>
            <div className={styles.landcalendermiddle}>
              <div className={styles.landingmainnewpage}>
                  <LandingPages/>
              </div>
            </div>
        </div> */}
      </div>
      {/* {notif && <NotificationBottom closeNotification={closeNotification} enablePermission={enablePermission} />} */}
      
      {/* <MonthlyMeetUp /> */}

      {/* <ChatToastLeft />
    <ChatToastRight /> */}
      {toastReducer.isLeftToast && <ToastLeft/>}
        {toastUndo.toastMessage &&<ToastUndo undo={true} message={toastUndo.toastMessage }
      onUndoClick={onUndoClick} closeToast={closeToast}></ToastUndo>}
      
      <Modal visible={profileDetails.isLeaveModel} className={`${styles.clearchatmodal} ${"modaloverwrite"}`}>
          <span className={`icon_close ${styles.cursorTop}`}  onClick={closeLeaveModal} />
        <h2>Leave {chatWindowDetails?.team_name}?</h2>          
          {/* <p>Team members will be notified that you left. You can rejoin anytime.</p>  */}
        {/* Private Leave Team */} 
      <p>You can no longer see, send, or receive any of the team messages. To rejoin 
      this team, you`ll need an invite from the admin... </p>
      {/* <p>You can no longer see, send, or receive any of the team messages. To rejoin this team, 
          you'll need an invite from the Admin.</p> */}
        <div className={styles.footersection}>
            <URButton className="urButton buttonWhite buttonMd mr8" onClick={closeLeaveModal} name="Cancel"></URButton>
            <URButton className="urButton buttonRed buttonMd" onClick={leaveFromTeam} name="Confirm"></URButton>
        </div>
      </Modal>
      <Modal visible={ArchiveModal.isDelete}
        className={`${styles.clearchatmodal} ${"modaloverwrite"}`}>
        <span onClick={handleCancel} className={`icon_close ${styles.cursorTop}`} />
        <h2>Delete this Chat?</h2>
        <p>You will not be able to retrieve this conversation history with {ArchiveModal?.deleteData?.team_id ?
          ArchiveModal?.deleteData?.team_name :
          ArchiveModal?.deleteData?.caller_id} once you delete the chat</p>
        <div className={styles.footersection}>
          <URButton className="urButton buttonWhite buttonMd mr8" onClick={handleCancel} name="Cancel"></URButton>
          <URButton className="urButton buttonRed buttonMd" onClick={deleteAction} name="Delete Chat"></URButton>
        </div>
      </Modal>

      {/* {(!gotNotifyPermission||!gotAudioPermission ||!gotVideoPermission)&& <div className="notifyBlock">
         <div className="arrowUp">
          <img src={arrowpermission} alt="permission arrow" />
         </div>
         <div className="permissionBlock">
          <span className="allowPermission">Allow permissions</span>
          <span className="allowPermissionDesc">Click ‘Allow’ so we can enable your <br/>microphone and camera</span>
         </div>
      </div>} */}

          
    </>
  );
};

export default Chats;
